__turbopack_context__.v({
  "accent": "Z6m4Za_accent",
  "agree": "Z6m4Za_agree",
  "button": "Z6m4Za_button",
  "container": "Z6m4Za_container",
  "content": "Z6m4Za_content",
  "description": "Z6m4Za_description",
  "dots": "Z6m4Za_dots",
  "form": "Z6m4Za_form",
  "input": "Z6m4Za_input",
  "overflow": "Z6m4Za_overflow",
  "row": "Z6m4Za_row",
  "title": "Z6m4Za_title",
});
